import api from "./api";

// ── Feedback Issues ─────────────────────────────────────────────────────────

export async function getFeedbackIssues() {
  try {
    const response = await api.get("feedback/issues/");
    return response.data;
  } catch (error) {
    throw error;
  }
}

// ── Submit Feedback ─────────────────────────────────────────────────────────

export async function submitFeedback(data = {}) {
  // data = { rating, issues, comment }
  try {
    const response = await api.post("feedback/submit/", data);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function checkFeedbackVisibility() {
  try {
    const res = await api.get("feedback/check/");
    return res.data;
  } catch (err) {
    console.error("Error checking feedback visibility:", err);
    return { show: false };
  }
}

export async function dismissFeedback(action) {
  try {
    const response = await api.post("feedback/dismiss/", { action });
    return response.data;
  } catch (error) {
    throw error;
  }
}